import { connect } from "react-redux";
import { refreshCpty } from "../actions";

const mapDispatchToProps = (dispatch) => ({
  setRefreshCpty: (data) => {
    dispatch(refreshCpty(data));
  },
});

const mapStateToProps = (state) => ({
  refreshCpty: state.refreshCpty,
});

export default connect(mapStateToProps, mapDispatchToProps);
